import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { apiFetch, getTheme, placeholder, validateEmail } from 'helpers'
import { get } from 'lodash'

import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'
import svgLoading from 'assets/svg/icon-loading.svg'

@connect(state => ({
  windowLoaded: get(state, 'app.windowLoaded')
}))
export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      emailError: ''
    }
  }

  componentDidMount () {
    const { dispatch, history } = this.props
    apiFetch({
      dispatch,
      key: 'VERIFY',
      v4: true,
      url: '/v4/vendors/me'
    })
      .then(result => history.replace('/profile'))
  }

  _onLogin = () => {
    if (this.state.loggingIn) return
    const errors = {
      emailError: !validateEmail(this.state.email),
      passwordError: !this.state.password
    }
    if (Object.keys(errors).some(key => errors[key])) {
      return this.setState(errors)
    }
    this.setState({ loggingIn: true, ...errors }, () =>
      apiFetch({
        dispatch: this.props.dispatch,
        method: 'POST',
        key: 'LOGIN',
        v4: true,
        url: '/v4/vendors/login',
        body: {
          email: this.state.email,
          password: this.state.password
        }
      })
        .then((result) => this.setState({ loggingIn: false }, () => {
          this.props.history.replace('/profile')
        }))
        .catch(result => this.setState({ loggingIn: false, userErrorMessage: get(result, 'statusCode') === 401 ? 'อีเมลหรือรหัสผ่านไม่ถูกต้อง' : '' }))
    )
  }

  render () {
    return (
      <Container>
        <HorizontalCentered>
          <VerticalCentered>
            <VendorLoginBodyContainer>
              <Heading>เข้าสู่ระบบ SabuyVendor</Heading>
              <form>
                <TextInput placeholder='อีเมล'
                  hasError={this.state.vendorEmailError}
                  value={this.state.vendorEmail}
                  onChange={e => this.setState({ email: e.target.value })} />
                <TextInput type='password' placeholder='รหัสผ่าน'
                  hasError={this.state.passwordError}
                  value={this.state.password}
                  onChange={e => this.setState({ password: e.target.value })} />
                {this.state.errorMessage && <ErrorMessage>{this.state.errorMessage}</ErrorMessage>}
                <Button style={{ marginBottom: 10 }} action='email-login' onClick={this._onLogin}>
                  {this.state.loggingIn ? <img alt='' src={svgLoading} /> : <span>เข้าสู่ระบบ</span>}
                </Button>
              </form>
              <ForgotPasswordLink action='to-forgot-password'>ลืมรหัสผ่าน?</ForgotPasswordLink>
            </VendorLoginBodyContainer>
          </VerticalCentered>
        </HorizontalCentered>
      </Container>
    )
  }
}

const Container = styled.section`
  background-color: ${getTheme`colorTiffany`};
`
const Heading = styled.h1`
  margin: 0px;
  padding: 0px;
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  padding-top: 30px;
`
const VendorLoginBodyContainer = styled.section`
  margin: 0 auto;
  border-radius: 5px;
  border: 1px solid ${getTheme`colorBorder`};
  box-shadow: 0 2px 4px 0 rgba(207, 207, 207, 0.5);
  padding: 15px;
  background-color: white;
`

const TextInput = styled.input`
  display: block;
  width: 100%;
  max-width: 400px;
  background-color: white;
  color: black;
  font-family: ${getTheme`font1`};
  padding: 0px;
  outline: none;
  text-indent: 10px;
  border-radius: 3px;
  margin-bottom: 5px;
  border: 1px solid ${getTheme`colorBorder`};
  ${props => `${placeholder(`color: ${props.theme.colorImageBackground}`)}`}
  ${props => props.hasError && `
    color: ${props.theme.colorCoral} !important;
    border: 1px solid ${props.theme.colorCoral} !important;
    ${placeholder(`color: ${props.theme.colorCoral}`)};
  `}

  @media(min-width: 600px) {
    display: block;
    height: 48px;
    line-height: 50px;
    font-size: 18px;
    margin: 0px auto 10px;
    text-indent: 20px;
  }
  @media(max-width: 599px) {
    height: 38px;
    line-height: 40px;
    font-size: 14px;
  }
`
const ForgotPasswordLink = styled.div`
  font-size: 16px;
  font-family: ${getTheme`font1`};
  color: ${getTheme`colorTiffanyDark`};
  cursor: pointer;
  &:hover { text-decoration: underline; }
  margin-bottom: 30px;
  text-align: center;
`
const ErrorMessage = styled.div`
  text-align: center;
  font-size: 16px;
  font-family: ${getTheme`font1`};
  color: ${getTheme`colorCoral`};  
`
const Button = styled.div`
  background-color: ${props => props.color ? props.theme[props.color] : props.theme.colorTiffany};
  border-radius: 5px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-family: ${getTheme`font1`};
  font-size: 18px;
  color: white;
  max-width: 420px;
  margin: 10px auto 30px;
  > img {
    vertical-align: top;
    margin-top: 17px;
    margin-right: 10px;
    width: 26px;
    height: 26px;
    vertical-align: top;
    filter: brightness(0) invert(1);
  }
`



// WEBPACK FOOTER //
// ./src/containers/Login.js